module.exports = __webpack_public_path__ + "img/ccompany-honor-RoHS-20240408.a8f56b60.jpg";